<div class="loading" fxLayout="row" fxLayoutAlign="center center">
  <i class="fa fa-spinner fa-spin fa-2x"></i> {{text == '' ? languages : text}}
</div>
